import { createWithEqualityFn } from 'zustand/traditional'
import { devtools } from 'zustand/middleware'

interface rpcCountState {
  count: number
  increment: () => void
}

export const useRpcCountStore = createWithEqualityFn<rpcCountState>()(
  devtools(
    (set) => ({
      count: 0,
      increment: () => set((state) => ({ count: state.count >= 2 ? 0 : state.count + 1 })),
    }),
    {
      name: 'rpcCount-storage',
    },
  ),
  Object.is,
)
